import { getSurgeonSurname } from '../../shared';

type DiscoveryHeaderInput = {
  locationName: string;
  timeLabel: string;
  surgeonName: string;
  procedureName: string;
  caseDisplayId: string;
};

export type DiscoveryHeader = {
  title: string;
  subtitle: string;
};

/** Header shown above the discovery card, e.g. "OR 3, 4:15pm, Leone" / "Total Knee - Case 100895". */
export const formatDiscoveryHeader = ({
  locationName,
  timeLabel,
  surgeonName,
  procedureName,
  caseDisplayId,
}: DiscoveryHeaderInput): DiscoveryHeader => ({
  title: `${locationName}, ${timeLabel}, ${getSurgeonSurname(surgeonName)}`,
  subtitle: `${procedureName} - Case ${caseDisplayId}`,
});
